export default __webpack_public_path__ + "static/media/information--parallel-parking--g1.c0d4c10a.png";